import { Add, ArrowBack } from '@mui/icons-material'
import { TextField } from '@mui/material'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { clone } from '../../../features/utils/objClone'
import { useDispatch } from 'react-redux'
import { setAlertMsg } from '../../../redux/reducers/modal/snackBarSlice'
import createAddonReq from '../../../controllers/settings/flights/createAddon'


const init = {
  "name":"",
  "descriptions":[""],
  "price":''
}
export default function CreateAddon() {
  const [data,setData] = useState(init);

  const dispatch = useDispatch();

  async function handleSubmit() {
    
    if (
      data.name === "" ||
      data.descriptions.length < 1 ||
      (Array.isArray(data.descriptions) && data.descriptions[0] === "") ||
      data.price === ""
    ) return dispatch(setAlertMsg(['error','Please input all fields!']))
    
    let filtered = clone(data);
    filtered.descriptions = filtered.descriptions.filter(val => val !== "")
    
    const res = await createAddonReq(filtered);
    if(res.return) {
      dispatch(setAlertMsg(['success','Add-on Added Successfull.']))
    } else dispatch(setAlertMsg(['error','Failed Creating Add-on']))

  }

  function setDescription(val,i) {
    let temp = clone(data);
    temp.descriptions[i] = val;
    setData(temp)
  }
  return (
    <div className='w-full bg-[#f3f3f3] p-4'>
      <div className='bg-secondary p-4'>
        <Link to="/settings/addons" className='flex gap-4'>
          <ArrowBack />
          <h3>Create an add-on</h3>
        </Link>
        <div className='inline-block py-4'>
          <div className='flex flex-col gap-2 w-auto'>
            <TextField size='small' label='Add-on Title'
              value={data.name} onChange={(ev) => setData(data => ({...data,name: ev.target.value}))} 
            />
            <div className='flex justify-end gap-2'>
              <button className='btn1'
                onClick={() => setData(data => ({...data,descriptions: [...data.descriptions,""]}))}
              ><Add /> Description</button>
            </div>
            {data.descriptions.map((val,i) => (
              <TextField key={i} multiline label='Description' rows={2} className='min-w-[70vh]'
                value={val} onChange={(ev) => setDescription(ev.target.value,i)}
              />
            ))}
            {/* <textarea placeholder='Description' className='min-w-[50%]'></textarea> */}
            <TextField size='small' type='number' label='Price'
              value={data.price} onChange={(ev) => setData(d => ({...data,price: ev.target.value}))}
            />
            <button className='btn2' onClick={handleSubmit}>Create Add-on</button>
          </div>
        </div>
      </div>
    </div>
  )
}
